import React, { useState } from 'react';
import { Card, CardContent, Button, Typography, Dialog, TextField, FormControl, InputLabel, Select, MenuItem, Box, IconButton } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CloseIcon from '@mui/icons-material/Close';
import { useAPI } from 'app/hooks/useApi';

const FileUpload = ({ processId, onUploadComplete }) => {
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({
    file: null,
    type: '',
    description: ''
  });
  const [error, setError] = useState('');
  const { makeRequest, loading } = useAPI();

  const acceptedFileType = 'application/pdf';

  const handleOpen = () => {
    setOpen(true);
    setError('');
  };

  const handleClose = () => {
    setOpen(false);
    setFormData({ file: null, type: '', description: '' });
    setError('');
    onUploadComplete?.();
  };

  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (file && file.type !== acceptedFileType) {
      setError('Por favor, selecione apenas arquivos PDF');
      setFormData(prev => ({ ...prev, file: null }));
      return;
    }
    setError('');
    setFormData(prev => ({ ...prev, file }));
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleUpload = async () => {
    if (!formData.file || !formData.type || !formData.description) return;

    const submitData = new FormData();
    submitData.append('file', formData.file);
    submitData.append('tipo', formData.type); 
    submitData.append('descricao', formData.description); 

    const response = await makeRequest(
      `processos-revistas-rpi/${processId}/upload`,
      'POST',
      submitData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );

    if (response.status === 200) {
      handleClose();
      onUploadComplete?.();
    }
  };

  return (
    <>
      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Anexar Arquivo
          </Typography>
          <Button
            variant="outlined"
            onClick={handleOpen}
            startIcon={<CloudUploadIcon />}
          >
            Anexar Novo Arquivo
          </Button>
        </CardContent>
      </Card>

      <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <CardContent>
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
            <Typography variant="h6" gutterBottom>
              Anexar Novo Arquivo
            </Typography>
            <IconButton onClick={handleClose} size="small">
              <CloseIcon />
            </IconButton>
          </Box>
          <Box component="form">
            <Box sx={{ flexGrow: 1, width: '100%', maxWidth: 800, mx: 'auto' }}>
              <Box display="flex" flexDirection="column" gap={2}>
                <TextField
                  fullWidth
                  select
                  label="Tipo do Arquivo"
                  name="type"
                  value={formData.type}
                  onChange={handleChange}
                  required
                  helperText="Selecione o tipo do anexo."
                >
                  <MenuItem value="LOGO">Logo</MenuItem>
                  <MenuItem value="PETICAO_DO_INPI">Petição do INPI</MenuItem>
                </TextField>
                <TextField
                  fullWidth
                  label="Descrição"
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  required
                  helperText="Descreva o conteúdo do arquivo."
                />
                <Button
                  variant="outlined"
                  component="label"
                  fullWidth
                  startIcon={<CloudUploadIcon />}
                >
                  Selecionar Arquivo
                  <input
                    type="file"
                    hidden
                    accept=".pdf,application/pdf"
                    onChange={handleFileSelect}
                  />
                </Button>
                <Box>
                  <Typography variant="body2" color="text.secondary">
                    <b>Tipo selecionado:</b> {formData.type === 'LOGO' ? 'Logo' : formData.type === 'PETICAO_DO_INPI' ? 'Petição do INPI' : '-'}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    <b>Descrição:</b> {formData.description || '-'}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    <b>Arquivo selecionado:</b> {formData.file ? formData.file.name : '-'}
                  </Typography>
                </Box>
                {error && (
                  <Typography color="error" variant="body2">
                    {error}
                  </Typography>
                )}
              </Box>
            </Box>
            <Button
              variant="contained"
              onClick={handleUpload}
              disabled={loading || !formData.file || !formData.type || !formData.description}
              fullWidth
              sx={{ mt: 2 }}
            >
              {loading ? 'Enviando...' : 'Enviar'}
            </Button>
          </Box>
        </CardContent>
      </Dialog>
    </>
  );
};

export default FileUpload;
